import { TobaccoUse } from '@hc-frontend/core-types';

export function tobaccoTextToTobaccoUse(
  tobacco: 'y' | 'n' | undefined,
): TobaccoUse | undefined {
  if (tobacco === undefined) return undefined;

  if (tobacco === 'y') {
    return TobaccoUse.Enum.YES;
  }

  return tobacco === 'n' ? TobaccoUse.Enum.NO : undefined;
}
